import logo from '../images/logo.svg'

const Logo = () => {
  return (
        <img src={logo}  alt='loo'/>
      )
}

export default Logo